// extracted by mini-css-extract-plugin
export default {"background":"angle-background_background__uCfeO"};